import AssetOverview from "../components/AssetOverview";
import { useParams } from "react-router-dom";
const AssetOverviewPage = () => {
  const params = useParams();
  return (
    <section className="">

      <AssetOverview />
    </section>
  );
};

export default AssetOverviewPage;